import { defineStore } from 'pinia'

export const useTokenStore = defineStore({
  id: 'token-store',
  state: () => {
  return {currentValue: ""}
  },
  actions: {
    updateToken(value: string) {
      this.currentValue = value;
    },
  },
  getters: {
    token: state => state.currentValue
  }
})
